import React, { useMemo, useCallback } from 'react'

import { Select, Modal } from 'antd'

export default React.memo(function ModeSelect({ onChange, ...props }) {
  const options = useMemo(() => {
    return [{
      label: 'gpt-3.5',
      value: 'gpt-3.5',
    }, {
      label: 'gpt-4（字数消耗*10）',
      value: 'gpt-4',
    }]
  }, [])

  const handleChange = useCallback(v => {
    onChange(v)
    if (v === 'gpt-4') {
      Modal.info({
        title: '提示',
        content: 'gpt-4字数消耗按10倍gpt-3.5进行计算。'
      })
    }
  }, [onChange])

  return (
    <Select options={options} {...props} onChange={handleChange}/>
  )
})
